import { render, staticRenderFns } from "./user-bio.vue?vue&type=template&id=2cf9f434&scoped=true"
import script from "./user-bio.vue?vue&type=script&lang=js"
export * from "./user-bio.vue?vue&type=script&lang=js"
import style0 from "./user-bio.vue?vue&type=style&index=0&id=2cf9f434&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cf9f434",
  null
  
)

export default component.exports